import React from 'react';

const FormMultiplierContext = React.createContext({
	onClick: () => {},
	isVisible: true,
});

interface FormMultiplierContextProviderProps {
	onClick: () => void;
	children: React.ReactElement | React.ReactElement[];
	isVisible?: boolean;
}

const FormMultiplierContextProvider: React.FC<
	FormMultiplierContextProviderProps
> = props => {
	const { children, onClick, isVisible = true } = props;

	return (
		<FormMultiplierContext.Provider
			value={{
				onClick,
				isVisible,
			}}
		>
			{children}
		</FormMultiplierContext.Provider>
	);
};

export const useFormMultiplierContext = () =>
	React.useContext(FormMultiplierContext);

export default FormMultiplierContextProvider;
